import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const CancelXIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "CancelXIcon", ...props, ref: ref, children: _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("path", { d: "M0 0h16v16H0z" }), _jsx("path", { d: "M3.5 3.5l9 9m0-9l-9 9", stroke: "currentcolor", strokeWidth: "1.5", strokeLinecap: "square" })] }) })));
CancelXIcon.displayName = "CancelXIcon";
